import type { ListTagSortProps } from "./list-tag-sort.type";

import { CaretDownFilled, CaretUpFilled } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

import { useListContext } from "@/modules/list";

import { ListTag } from "../list-tag.component";

export const ListTagSort = ({ sortKey }: ListTagSortProps) => {
  const { t } = useTranslation();
  const { columnsOptions, clearSort } = useListContext();

  const cleanKey = sortKey.startsWith("-") ? sortKey.slice(1) : sortKey;

  const column = columnsOptions.find((column) => column.sortKey === cleanKey);
  const title = column?.title ?? cleanKey;

  const isUp = sortKey === cleanKey;
  const icon = isUp ? <CaretUpFilled /> : <CaretDownFilled />;

  return (
    <ListTag
      icon={icon}
      onClose={() => clearSort(sortKey)}
      closeAriaLabel={t("global:listResetActions.removeSort")}
    >
      {title}
    </ListTag>
  );
};
